import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-50">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-md">
              精选高分韩漫，品质保证，让你不再漫荒
            </p>
          </div>
          <Link
            to="/category/qihuan"
            className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-1">
            <ComicCard comic={featuredComics[0]} featured />
          </div>
          <div className="lg:col-span-2 grid grid-cols-2 md:grid-cols-2 gap-4">
            {featuredComics.slice(1, 5).map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}